"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tracker = void 0;
var getCookieAnonymousId_1 = require("./getCookieAnonymousId");
var isDoNotTrackEnabled_1 = require("./utils/isDoNotTrackEnabled");
var isEventDuplicate_1 = require("./utils/isEventDuplicate");
var convertKeys = function (input) {
    return Object.keys(input).reduce(function (transformed, key) {
        var _a;
        var transformedKey = key.replace(/[A-Z]/g, function (char) { return "_".concat(char.toLowerCase()); });
        return __assign(__assign({}, transformed), (_a = {}, _a[transformedKey] = input[key], _a));
    }, {});
};
var Tracker = /** @class */ (function () {
    function Tracker(options) {
        this.queue = [];
        var endpointUrl = options.endpointUrl, user = options.user, _a = options.deduplicateInterval, deduplicateInterval = _a === void 0 ? 3000 : _a, deduplicator = options.deduplicator, _b = options.getAnonymousId, getAnonymousId = _b === void 0 ? getCookieAnonymousId_1.getCookieAnonymousId : _b;
        if (typeof endpointUrl !== 'string') {
            throw new TypeError("\"endpointUrl\" must be a string, but got \"".concat(endpointUrl, "\""));
        }
        this.endpointUrl = endpointUrl;
        this.deduplicateInterval = deduplicateInterval;
        this.deduplicator = deduplicator;
        this.user = __assign(__assign({}, user), { anonymousId: getAnonymousId() });
    }
    /**
     * Correlates an anonymous user id with a verified user id.
     * This allows the tracking endpoint to issue an alias event and link
     * any previously anonymous actions with a known user id.
     * @param user the user id and any associated context
     * @param additional any additional properties to include in the event
     */
    Tracker.prototype.identify = function (_a, additional) {
        var id = _a.id, context = __rest(_a, ["id"]);
        if (!id) {
            throw new TypeError("user.id must be set, but got \"".concat(id, "\""));
        }
        this.user = __assign({ id: id, anonymousId: this.user.anonymousId }, context);
        return this.track('alias', __assign({ user_id: id, previous_id: this.user.anonymousId }, additional));
    };
    /**
     * Clears all user context from this Tracker instance.
     * This can be used to reset the tracker after a user logs out.
     */
    Tracker.prototype.reset = function () {
        this.flush(); // don't care if this finishes, just kick it off
        this.user = { anonymousId: this.user.anonymousId };
    };
    /**
     * Flushes all events currently in the queue to the configured
     * tracking endpoint. Returns a promise that resolves once all
     * events have been flushed.
     *
     * You should not usually need to call this manually.
     */
    Tracker.prototype.flush = function () {
        return __awaiter(this, void 0, void 0, function () {
            var batch;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.timeout) {
                            // if called manually, ensure the timed copy doesn't also run
                            clearTimeout(this.timeout);
                        }
                        batch = this.queue.splice(0, this.queue.length);
                        return [4 /*yield*/, Promise.all(batch.map(function (payload) { return __awaiter(_this, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _b.trys.push([0, 2, , 3]);
                                            return [4 /*yield*/, fetch(this.endpointUrl, {
                                                    method: 'POST',
                                                    body: JSON.stringify(payload),
                                                    headers: {
                                                        'Content-Type': 'application/json',
                                                    },
                                                })];
                                        case 1:
                                            _b.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            _a = _b.sent();
                                            // we can safely retry failures during the next window
                                            this.queue.push(payload);
                                            return [3 /*break*/, 3];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _a.sent();
                        this.timeout = window.setTimeout(function () { return _this.flush(); }, this.deduplicateInterval);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Tracks an event.
     * @param type the type of event being tracked
     * @param properties an object containing event properties
     * @param [optional] contextOverride an object containing context override properties
     */
    Tracker.prototype.track = function (type, properties, contextOverride) {
        var _this = this;
        if (contextOverride === void 0) { contextOverride = {}; }
        if ((0, isDoNotTrackEnabled_1.isDoNotTrackEnabled)()) {
            return;
        }
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        var payload = {
            event_type: type,
            timestamp: new Date(Date.now()).toISOString(),
            properties: properties,
            context: __assign({ page: {
                    path: window.location.pathname,
                    search: window.location.search,
                    title: document.title,
                    referrer: document.referrer,
                    url: window.location.href,
                }, user: convertKeys(this.user) }, contextOverride),
        };
        var previous = this.queue.length - 1;
        if ((0, isEventDuplicate_1.isEventDuplicate)(payload, this.queue[previous], {
            ignoredKeys: ['timestamp'],
            deduplicator: this.deduplicator,
        })) {
            this.queue[previous] = payload;
        }
        else {
            this.queue.push(payload);
        }
        this.timeout = window.setTimeout(function () { return _this.flush(); }, this.deduplicateInterval);
    };
    return Tracker;
}());
exports.Tracker = Tracker;
